import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Cookies } from "react-cookie";
import { Table, Tag } from "antd";
import SheetApprovalComponent from "./sheetApproval";
import { uploadCsv } from "../../../../redux/slice/uploadCSVSlice";
import { fetchWhitelistUsers } from "../../../../redux/slice/fetchWhitelistUsersSlice";
import upld_img_icn from "../../../../assets/images/upload.png";
import "./sheetApproval.scss";
import Notify from "../../common/notify/notify";

const SheetApproval = (props) => {
  const {
    callUploadCsv,
    isUploading,
    isFetching,
    callFetchWhitelistUsers,
    userListData,
  } = props;

  const [csvFile, setCsvFile] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const cookies = new Cookies();
  const id = cookies.get("societyId");

  useEffect(() => {
    if (id) {
      callFetchWhitelistUsers(id);
    }
  }, [callFetchWhitelistUsers, id]);

  const userList = userListData?.userList?.data?.data;

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setCsvFile(file);
    }
  };

  const handleDownloadSample = () => {
    const link = document.createElement("a");
    link.href = "/UserRegisterSample.csv";
    link.setAttribute("download", "UserRegisterSample.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUpload = async () => {
    if (!csvFile) {
      Notify("error", "Please select a CSV file to upload.", "");
      return;
    }

    const uploadPayload = {
      id: id,
      csvFile: csvFile,
    };

    try {
      const result = await callUploadCsv(uploadPayload);

      if (uploadCsv.fulfilled.match(result)) {
        Notify("success", "The CSV file has been uploaded successfully", "");
        setCsvFile(null);
        if (id) {
          callFetchWhitelistUsers(id);
        }
        const fileInput = document.querySelector(".file-input");
        if (fileInput) fileInput.value = "";
      } else if (uploadCsv.rejected.match(result)) {
        const errorMessage =
          result.payload || "An error occurred during the upload.";
        Notify("error", errorMessage, "");
      }
    } catch (error) {
      Notify("error", "An unexpected error occurred. Please try again.", "");
    }
  };

  const handleTableChange = (paginationConfig) => {
    setPagination(paginationConfig);
  };

  const columns = [
    {
      title: "Sr. No.",
      key: "sr_no",
      render: (text, record, index) => {
        const srNo = (pagination.current - 1) * pagination.pageSize + index + 1;
        return <span>{srNo.toString().padStart(2, "0")}</span>;
      },
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "Wing",
      dataIndex: "wing",
      key: "wing",
    },
    {
      title: "Flat",
      dataIndex: "flat",
      key: "flat",
    },
    {
      title: "Registered",
      dataIndex: "is_registered",
      key: "is_registered",
      render: (isRegistered) => (
        <Tag color={isRegistered ? "green" : "red"}>
          {isRegistered ? "Yes" : "No"}
        </Tag>
      ),
    },
  ];

  const items = [
    {
      key: "1",
      label: "Upload & View User List",
      children: (
        <div>
          <div className="logo-main">
            <div className="logo-top">
              <p className="logo-text">
                Simply upload a CSV file with their details. Users will be added
                and granted access immediately, without needing any further
                approval.
              </p>
              <div
                className="download-sample-wrapper"
                style={{
                  marginTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <button
                  onClick={handleDownloadSample}
                  className="submit-logo-btn"
                >
                  Download Sample CSV
                </button>
                <p style={{ marginTop: "4px", fontSize: "12px", color: "red" }}>
                  *Download the sample file to see the required format for the
                  user registration CSV.
                </p>
              </div>
            </div>
            <div className="logo-bottom">
              <div
                className="logo-upload-container"
                onClick={() => document.querySelector(".file-input")?.click()}
              >
                <div className="upload-icon">
                  <img src={upld_img_icn} alt="Upload CSV" />
                </div>
                <p className="upload-text">
                  {csvFile ? csvFile.name : "Upload List"}
                </p>
                <p className="upload-subtext">Click to upload a CSV file</p>
                <input
                  type="file"
                  accept=".csv"
                  onChange={handleFileChange}
                  className="file-input"
                  style={{ display: "none" }}
                  disabled={isUploading}
                />
              </div>
            </div>
            <div className="logo-submit-btn">
              <button
                className="submit-logo-btn"
                onClick={handleUpload}
                disabled={isUploading || !csvFile}
              >
                <span>{isUploading ? "Uploading..." : "Upload File"}</span>
              </button>
            </div>
          </div>

          <div style={{ marginTop: "20px" }}>
            <h2 style={{ marginBottom: "10px" }}>User List</h2>
            <Table
              dataSource={userList}
              columns={columns}
              rowKey={(record) =>
                `${record.phone_number}-${record.wing}-${record.flat}`
              }
              pagination={{
                ...pagination,
                position: ["bottomCenter"],
              }}
              onChange={handleTableChange}
              loading={isFetching}
              scroll={{ x: "max-content" }}
            />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <SheetApprovalComponent items={items} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isUploading: state.uploadCsv?.isLoading || false,
    isFetching: state.fetchWhitelistUsers?.isLoading || false,
    userListData: state.userListData || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    callUploadCsv: (data) => dispatch(uploadCsv(data)),
    callFetchWhitelistUsers: (id) => dispatch(fetchWhitelistUsers(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SheetApproval);
